import SwitchBills from '../../../bankingSwitch/components/SwitchBills';

const SwitchBillsScreen = () => {
    return <SwitchBills />;
};

export default SwitchBillsScreen;
